import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { fetchAccommodationDetail } from '../services/accommodationApi';

/**
 * Custom hook to fetch accommodation details
 * Can be used in both mobile and desktop components
 *
 * @param {string} defaultAccommodationId - Default accommodation ID if not in URL
 * @returns {Object} { accommodationDetail, isLoadingAccommodation, error }
 */
export const useAccommodationDetail = (defaultAccommodationId = ' ') => {
  const [searchParams] = useSearchParams();
  const [accommodationDetail, setAccommodationDetail] = useState(null);
  const [isLoadingAccommodation, setIsLoadingAccommodation] = useState(false);
  const [error, setError] = useState(null);

  // Only extract hotel_id - ignore other param changes (currency, language, etc.)
  const hotelId = searchParams.get('hotel_id') ||
                  searchParams.get('accommodationid') ||
                  defaultAccommodationId;

  useEffect(() => {
    const fetchAccommodation = async () => {
      if (hotelId) {
        setIsLoadingAccommodation(true);
        setError(null);
        try {
          const detail = await fetchAccommodationDetail(hotelId);
          setAccommodationDetail(detail);
        } catch (err) {
          setError(err.message || 'Failed to fetch accommodation details');
          // Don't show error to user, just use default
        } finally {
          setIsLoadingAccommodation(false);
        }
      }
    };

    fetchAccommodation();
  }, [hotelId]);

  return {
    accommodationDetail,
    isLoadingAccommodation,
    error
  };
};
